import React, { Component } from 'react';

import { getJson } from '../helpers/RequestsHelper'
import AccountSelectItem from './AccountSelectItem';
import AccountConnectComponent from './AccountConnectComponent'
import { withTranslation } from 'react-i18next';

class AccountSelect extends Component {

    state = {
        loading: true,
        loginUrl: ""
    }

    constructor(props) {
        super(props)
        this.connectNewClick = this.connectNewClick.bind(this)
        this.callAPI = this.callAPI.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.onItemUpdate = this.onItemUpdate.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        state.accountType = props.accountType
        state.requiredScope = props.requiredScope
        if (!state.accountId && props.selectedAccountId) {
            state.accountId = props.selectedAccountId
        }

        const lastAddedAccount = localStorage.getItem("lastAddedAccount")
        if (lastAddedAccount) {
            state.accountId = lastAddedAccount
            localStorage.removeItem("lastAddedAccount")
        }

        return state
    }

    componentDidMount() {
        this.callAPI();
    }

    async callAPI() {
        var path = process.env.REACT_APP_SERVER_BASE_URL + "/myapps?redirect=" + encodeURI(window.location.pathname + (window.location.search ? window.location.search : ""));

        if (this.state.accountType) {
            path += "&accountType=" + this.state.accountType
        }



        const json = await getJson(path);
        if (json.error === "fail") {
            if (this.state.error) {
                this.setState({ loading: false, error2: true })
            } else {
                this.setState({ loading: false, error: true })
            }
        } else {
            this.setState({ loading: false, error: false, accounts: json }, () => {
                if (json.length >= 1) {
                    if (this.state.accountId) {
                       // this.onSelect(this.state.accounts.find(a => a.accountId == this.state.accountId));
                    } else {
                        this.onSelect(json[0].accountId);
                    }
                }
            })

        }
    }

    connectNewClick() {
        this.setState({ accountId: "", connected: false })
        this.callAPI(undefined, "new")
    }

    onSelect(accountId) {
        this.setState({ accountId: accountId })
        this.updateParent(accountId)
    }

    onItemUpdate(account) {
        if (this.state.accountId == account.accountId) {
            this.updateParent(this.state.accountId)
            //this.setState({accountId: account.accountId});
            this.setState({});
        }
    }

    updateParent(selectedAccountId) {
        const account = this.state.accounts.find(a => a.accountId == selectedAccountId)
        this.props.onChange(account)
        if (account && account.connected) {
            //this.props.onChange(account)
        } else {
            this.props.onChange(undefined)
        }
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <div className="spinner-border" role="status">
                <span className="sr-only">{t("loading")}</span>
            </div>
        }

        if (this.state.error) {
            if (this.state.error2) {
                return (<div>{t("msg_retry")}<input type="button" className="submit-btn-2" value={t("btntryagain")} onClick={this.callAPI} /></div>)
            } else {
                return (<div>{t("errormsgformsubmission")}<input type="button" className="submit-btn-2" value={t("btntryagain")} onClick={this.callAPI} /></div>)
            }
        }

        if (!this.state.accounts || this.state.accounts.length === 0) {
            return (
                <div className="list-group">
                    <AccountConnectComponent account={{ type: this.state.accountType, accountId: this.state.accountType }} new="true" requiredScope={this.state.requiredScope} key={this.state.accountType} />
                </div>
            )
        }

        let accountItems = []
        let selectedAccount = undefined
        if (this.state.accounts) {
            this.state.accounts.forEach(account => {
                if (this.state.accountId == account.accountId) {
                    selectedAccount = account
                }
                accountItems.push(<AccountSelectItem key={account.accountId} onClick={this.onSelect} id={account.accountId} name={account.name} />)
                // accountItems.push(
                //     <AccountSelectItem onClick={this.onSelect} account={account} requiredScope={this.state.requiredScope} key={account.accountId} selected={this.state.accountId} onUpdate={this.onItemUpdate}></AccountSelectItem>
                // )
            })
        }

        accountItems.push(<AccountSelectItem key={this.state.accountType} onClick={this.onSelect} id={this.state.accountType} name={t("account_new")} />)

        return (
            <table><tbody><tr><td>
                <div className="dropdown show w-300">
                    <button className="dropdown-toggle filter_selector" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {selectedAccount ? selectedAccount.name : t(this.state.accountType)}
                    </button>

                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        {accountItems}
                    </div>
                </div>
            </td><td>
                    {selectedAccount ?

                        <AccountConnectComponent account={selectedAccount} requiredScope={this.state.requiredScope} className="col-8 hover" onUpdate={this.onItemUpdate} key={this.state.accountId} />
                        // <AccountSelectItem onClick={this.onSelect} account={selectedAccount} requiredScope={this.state.requiredScope} selected={this.state.accountId} onUpdate={this.onItemUpdate}></AccountSelectItem>
                        :
                        <AccountConnectComponent account={{ type: this.state.accountType, accountId: this.state.accountType }} new="true" requiredScope={this.state.requiredScope} key={this.state.accountType} />
                    }
                </td></tr></tbody>
            </table>
        )
    }
}

export default withTranslation()(AccountSelect)

